import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowRight, Megaphone } from "lucide-react";
import { PublicHeader } from "@/components/public-layout";

export const Route = createFileRoute("/upgrade-success")({
	head: () => ({
		meta: [{ name: "robots", content: "noindex, nofollow" }],
	}),
	component: UpgradeRetiredPage,
});

function UpgradeRetiredPage() {
	const navigate = useNavigate();

	return (
		<div className="min-h-svh bg-background">
			<PublicHeader />

			<main className="max-w-lg mx-auto px-4 py-16">
				<div className="border border-border bg-card p-6 sm:p-8">
					<div className="mx-auto mb-5 inline-flex size-10 items-center justify-center border border-border bg-background text-muted-foreground">
						<Megaphone className="size-4" />
					</div>

					<p className="font-mono text-sm uppercase tracking-[0.14em] text-muted-foreground">
						&gt; Upgrade
					</p>
					<h1
						className="mt-2 font-mono text-2xl leading-tight tracking-[-0.02em] text-foreground"
						style={{ fontWeight: 400 }}
					>
						<span className="text-brand">/</span>retired
					</h1>

					<p className="mt-3 text-base leading-[1.55] text-muted-foreground">
						AgentMRR no longer runs subscription upgrade checkouts. Advertising
						placements are still available.
					</p>

					<button
						type="button"
						onClick={() => navigate({ to: "/" })}
						className="mt-6 inline-flex w-full min-h-11 items-center justify-center gap-2 bg-brand px-5 font-mono text-sm uppercase tracking-[0.14em] text-background transition-colors hover:bg-brand-hover"
					>
						View advertising options
						<ArrowRight className="size-3.5" />
					</button>
				</div>
			</main>
		</div>
	);
}
